import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AngleProcessingAvailability, AngleSettingsHelper, CuttingFacadeOutline, MaterialType } from 'cloud-shared-lib';
import { Observable, of } from 'rxjs';

import { CuttingPanelBaseSlot } from '../../../models/cutting/cutting-panel-base-slot.model';
import { AngleMode, AnglePosition, CuttingPanelOutline } from '../../../models/cutting/cutting-panel-outline.model';

@Component({
  selector: 'csl-angle-mode-select',
  templateUrl: './angle-mode-select.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class AngleModeSelectComponent implements OnInit {
  // outlineOptions: OutlineEditorOptions;
  thisAngleMode = AngleMode;
  private _angles: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline = undefined;
  _mode: AngleMode = AngleMode.None;
  thisMaterialType = MaterialType;
  availableMods$: Observable<Set<AngleMode>>;

  withoutProcessingText = $localize`Нет`;

  get angles(): CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline {
    return this._angles;
  }

  @Output() modeChange: EventEmitter<AngleMode> = new EventEmitter<AngleMode>();

  @Input() editable = true;
  @Input() set mode(value: AngleMode) {
    this._mode = value;
  }
  @Input() anglePosition: AnglePosition = undefined;
  @Input() set outline(val: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline) {
    this._angles = val;
  }
  @Input() materialType: MaterialType;

  @Input() angleProcessingAvailability: AngleProcessingAvailability;

  @Input()
  get dense(): boolean {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  _excludeModes: { [key: string]: boolean } = {};

  constructor() {}

  ngOnInit(): void {
    this.availableMods$ = of(AngleSettingsHelper.getAngleMods(this.angleProcessingAvailability));
  }

  onModeChange(): void {
    this.modeChange.emit(this._mode);
  }

  validDiagonalCut(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode === AngleMode.None &&
          this.angles.topRight.mode === AngleMode.None &&
          this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode === AngleMode.None &&
          this.angles.bottomRight.mode === AngleMode.None &&
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode === AngleMode.None &&
          this.angles.bottomLeft.mode === AngleMode.None &&
          this.angles.topLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode === AngleMode.None &&
          this.angles.bottomRight.mode === AngleMode.None &&
          this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validRounding(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validRoundingInside(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validCut(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validCutInside(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validCutInsideWithAngle(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validChamfer(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validMasonsMitreMale(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }

  validMasonsMitreFemale(): boolean {
    if (!this.angles) {
      return false;
    }

    switch (this.anglePosition) {
      case 'tl':
        return (
          this.angles.bottomLeft.mode !== AngleMode.DiagonalCut && this.angles.topRight.mode !== AngleMode.DiagonalCut
        );

      case 'tr':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      case 'br':
        return (
          this.angles.topRight.mode !== AngleMode.DiagonalCut && this.angles.bottomLeft.mode !== AngleMode.DiagonalCut
        );

      case 'bl':
        return (
          this.angles.topLeft.mode !== AngleMode.DiagonalCut && this.angles.bottomRight.mode !== AngleMode.DiagonalCut
        );

      default:
        return false;
    }
  }
}
